import type { BugReport } from "../shared/bug-reports";

// Keep user-facing errors predictable; never display arbitrary server responses.
export function reportFailure(status: number): string {
  switch (status) {
    case 400:
    case 415:
      return "Check your message and screenshots, then try again.";
    case 401:
      return "Sign in again to send. Your draft is saved in this tab.";
    case 403:
      return "Sending is unavailable. Download your report instead.";
    case 409:
      return "This reference is already used. Edit your message and try again.";
    case 413:
      return "Report too large. Remove a screenshot and try again.";
    case 429:
      return "Report limit reached. Try later or download your report.";
    default:
      return "Couldn’t send. Your draft is here. Retry or download it.";
  }
}

export async function sendBugReport(report: BugReport) {
  let response: Response;
  try {
    response = await fetch("/api/bug-reports", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
      signal: AbortSignal.timeout(15_000),
    });
  } catch (error) {
    if (error instanceof Error && error.name === "TimeoutError") throw error;
    throw new Error(reportFailure(0));
  }
  if (!response.ok) throw new Error(reportFailure(response.status));
  let receipt;
  try {
    receipt = await response.json();
  } catch {
    throw new Error("No receipt received. Retry or download your report.");
  }
  if (receipt?.id !== report.id)
    throw new Error("No receipt received. Retry or download your report.");
}
